import '../icon/index.js';

import type {TemplateResult} from 'lit';
import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import styles from './style.scss';
import {isLastIndex} from '#lit/utils/arrays.js';

export const BREADCRUMBS_ELEMENT_TAG = 'fly-breadcrumbs';

export interface Breadcrumb {
  href: string;
  label: string;
}

/**
 * Uses a JSON list to render breadcrumbs for a page.
 */
@customElement(BREADCRUMBS_ELEMENT_TAG)
export default class Breadcrumbs extends FlywheelComponent {
  @property({type: Array})
  items: Breadcrumb[] = [];

  static get styles() {
    return [styles];
  }

  renderSeparator(): TemplateResult {
    return html`
      <div class="fly-breadcrumbs__separator">
        <fly-icon icon="keyboard_arrow_right"></fly-icon>
      </div>
    `;
  }

  render() {
    return html`
      <div class="fly-breadcrumbs">
        ${this.items.map((breadcrumb, idx) => {
          return html`
            <div class="fly-breadcrumbs__item">
              ${isLastIndex(idx, this.items) ? this.renderSeparator() : ''}
              ${isLastIndex(idx, this.items)
                ? breadcrumb.label
                : html`
                    <a
                      class="fly-breadcrumbs__item__href"
                      href=${breadcrumb.href}
                    >
                      ${breadcrumb.label}
                    </a>
                  `}
            </div>
          `;
        })}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [BREADCRUMBS_ELEMENT_TAG]: Breadcrumbs;
  }
}
